const isMobile = () => window.matchMedia("(max-width: 768px)").matches;

const observer = new MutationObserver(() => {
  const imgEl = document.querySelector(".octane-popup__img");
  const descEl = document.querySelector(".octane-popup__description span");

  if (imgEl && !imgEl.dataset.bgSet && isMobile()) {
    imgEl.style.backgroundImage =
      "url('https://cdn.shopify.com/s/files/1/0638/3760/1930/files/vip_modal_mobile_430x.jpg?v=1761049258')";
    imgEl.dataset.bgSet = "true";
  }

  if (descEl && descEl.textContent.includes("|") && !descEl.dataset.processed) {
    const items = descEl.textContent
      .split("|")
      .map(i => i.trim())
      .filter(Boolean);

    const ul = document.createElement("ul");

    items.forEach(text => {
      const li = document.createElement("li");
      li.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
          <rect x="0.5" y="0.558594" width="24" height="24" rx="12" fill="#1164FD"/>
          <path d="M18.2592 8.76385L10.6697 16.3534L6.74078 12.4244" stroke="white" stroke-width="2"/>
        </svg>
        <span>${text}</span>
      `;
      ul.appendChild(li);
    });

    descEl.parentNode.replaceChild(ul, descEl);
    descEl.dataset.processed = "true";
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

setInterval(() => {
  const backButton = document.querySelector('.oct-quiz-btn[title="Back"]');
  const relativeWrapper = document.querySelector('.oct-quiz-btn-wrapper[data-element="oct-quiz-btn oct-quiz-submit-btn oct-quiz-media"]');
  if(!backButton || !relativeWrapper) return;

  const wrapperRect = relativeWrapper.getBoundingClientRect();
  const top = wrapperRect.top + window.scrollY + (wrapperRect.height / 2) - (backButton.offsetHeight / 2);
  const left = wrapperRect.left + window.scrollX;

  Object.assign(backButton.style, {
    position: 'absolute',
    top: `${top}px`,
    left: `${left}px`,
    margin: 0,
    zIndex: 9999999,
  });
}, 500);
